"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SapphireCoreV1Factory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var SapphireCoreV1Factory = /** @class */ (function (_super) {
    __extends(SapphireCoreV1Factory, _super);
    function SapphireCoreV1Factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    SapphireCoreV1Factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    SapphireCoreV1Factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    SapphireCoreV1Factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    SapphireCoreV1Factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    SapphireCoreV1Factory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return SapphireCoreV1Factory;
}(contracts_1.ContractFactory));
exports.SapphireCoreV1Factory = SapphireCoreV1Factory;
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "enum SapphireTypes.Operation",
                        name: "operation",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "userToLiquidate",
                        type: "address",
                    },
                ],
                indexed: false,
                internalType: "struct SapphireTypes.Action[]",
                name: "_actions",
                type: "tuple[]",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "score",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "merkleProof",
                        type: "bytes32[]",
                    },
                ],
                indexed: false,
                internalType: "struct SapphireTypes.ScoreProof",
                name: "_scoreProof",
                type: "tuple",
            },
            {
                indexed: true,
                internalType: "address",
                name: "_user",
                type: "address",
            },
        ],
        name: "ActionsOperated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_newAssessor",
                type: "address",
            },
        ],
        name: "AssessorUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "_lowCollateralRatio",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_highCollateralRatio",
                type: "uint256",
            },
        ],
        name: "CollateralRatiosUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_feeCollector",
                type: "address",
            },
        ],
        name: "FeeCollectorUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "_newIndex",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_lastUpdateTime",
                type: "uint256",
            },
        ],
        name: "IndexUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "_value",
                type: "uint256",
            },
        ],
        name: "InterestRateUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_newInterestSetter",
                type: "address",
            },
        ],
        name: "InterestSetterUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "_totalBorrowLimit",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_vaultBorrowMinimum",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_vaultBorrowMaximum",
                type: "uint256",
            },
        ],
        name: "LimitsUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "_liquidationUserRatio",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_liquidationArcRatio",
                type: "uint256",
            },
        ],
        name: "LiquidationFeesUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_oracle",
                type: "address",
            },
        ],
        name: "OracleUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "_newPauseOperator",
                type: "address",
            },
        ],
        name: "PauseOperatorUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bool",
                name: "_pauseStatus",
                type: "bool",
            },
        ],
        name: "PauseStatusUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "_destination",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
        ],
        name: "TokensWithdrawn",
        type: "event",
    },
    {
        constant: true,
        inputs: [],
        name: "accumulatedInterest",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "assessor",
        outputs: [
            {
                internalType: "contract ISapphireAssessor",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "score",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "merkleProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct SapphireTypes.ScoreProof",
                name: "_scoreProof",
                type: "tuple",
            },
        ],
        name: "borrow",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "borrowIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "uint256",
                name: "_borrowedAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_collateralAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_collateralPrice",
                type: "uint256",
            },
        ],
        name: "calculateCollateralRatio",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "collateralAsset",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "currentBorrowIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "currentTimestamp",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "score",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "merkleProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct SapphireTypes.ScoreProof",
                name: "_scoreProof",
                type: "tuple",
            },
        ],
        name: "deposit",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "amount",
                        type: "uint256",
                    },
                    {
                        internalType: "enum SapphireTypes.Operation",
                        name: "operation",
                        type: "uint8",
                    },
                    {
                        internalType: "address",
                        name: "userToLiquidate",
                        type: "address",
                    },
                ],
                internalType: "struct SapphireTypes.Action[]",
                name: "_actions",
                type: "tuple[]",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "score",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "merkleProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct SapphireTypes.ScoreProof",
                name: "_scoreProof",
                type: "tuple",
            },
        ],
        name: "executeActions",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                components: [
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "score",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "merkleProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct SapphireTypes.ScoreProof",
                name: "_scoreProof",
                type: "tuple",
            },
        ],
        name: "exit",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "feeCollector",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "getAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "highCollateralRatio",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "indexLastUpdate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_collateralAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "_syntheticAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "_oracleAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "_interestSetter",
                type: "address",
            },
            {
                internalType: "address",
                name: "_pauseOperator",
                type: "address",
            },
            {
                internalType: "address",
                name: "_assessorAddress",
                type: "address",
            },
            {
                internalType: "address",
                name: "_feeCollector",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_highCollateralRatio",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_lowCollateralRatio",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_liquidationUserRatio",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_liquidationArcRatio",
                type: "uint256",
            },
        ],
        name: "init",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "interestRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "interestSetter",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "_currentPrice",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_assessedCRatio",
                type: "uint256",
            },
        ],
        name: "isCollateralized",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_owner",
                type: "address",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "score",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "merkleProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct SapphireTypes.ScoreProof",
                name: "_scoreProof",
                type: "tuple",
            },
        ],
        name: "liquidate",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "liquidationArcRatio",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "liquidationUserRatio",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "lowCollateralRatio",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "oracle",
        outputs: [
            {
                internalType: "contract ISapphireOracle",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "pauseOperator",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "paused",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "precisionScalar",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "score",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "merkleProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct SapphireTypes.ScoreProof",
                name: "_scoreProof",
                type: "tuple",
            },
        ],
        name: "repay",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_assessor",
                type: "address",
            },
        ],
        name: "setAssessor",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "_lowCollateralRatio",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_highCollateralRatio",
                type: "uint256",
            },
        ],
        name: "setCollateralRatios",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_newFeeCollector",
                type: "address",
            },
        ],
        name: "setFeeCollector",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "_liquidationUserRatio",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_liquidationArcRatio",
                type: "uint256",
            },
        ],
        name: "setFees",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "_interestRate",
                type: "uint256",
            },
        ],
        name: "setInterestRate",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_interestSetter",
                type: "address",
            },
        ],
        name: "setInterestSetter",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "_totalBorrowLimit",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_vaultBorrowMinimum",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "_vaultBorrowMaximum",
                type: "uint256",
            },
        ],
        name: "setLimits",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_oracleAddress",
                type: "address",
            },
        ],
        name: "setOracle",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bool",
                name: "_value",
                type: "bool",
            },
        ],
        name: "setPause",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_pauseOperator",
                type: "address",
            },
        ],
        name: "setPauseOperator",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "syntheticAsset",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "totalBorrowLimit",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "totalBorrowed",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "totalCollateral",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "updateIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "vaultBorrowMaximum",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "vaultBorrowMinimum",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "vaults",
        outputs: [
            {
                internalType: "uint256",
                name: "collateralAmount",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "borrowedAmount",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "_amount",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "address",
                        name: "account",
                        type: "address",
                    },
                    {
                        internalType: "uint256",
                        name: "score",
                        type: "uint256",
                    },
                    {
                        internalType: "bytes32[]",
                        name: "merkleProof",
                        type: "bytes32[]",
                    },
                ],
                internalType: "struct SapphireTypes.ScoreProof",
                name: "_scoreProof",
                type: "tuple",
            },
        ],
        name: "withdraw",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "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";
